import type { MapProviderProps } from "./map-provider.type";

import { APIProvider } from "@vis.gl/react-google-maps";

import { useAppLocale } from "@/services/language";

import { logMap, errorMap, getGoogleMapsApiKey } from "../map.helper";

import { DEFAULT_LIBRARIES, DEFAULT_REGION } from "./map-provider.constant";

/**
 * Provider component for Google Maps
 */
const MapProvider = ({ children }: MapProviderProps) => {
  const locale = useAppLocale();
  const apiKey = getGoogleMapsApiKey();

  const handleApiLoad = () => {
    logMap("MapProvider", "Google Maps API loaded successfully");
  };

  const handleApiError = (error: unknown) => {
    errorMap("MapProvider", "Google Maps API failed to load:", error);
  };

  return (
    <APIProvider
      apiKey={apiKey}
      libraries={DEFAULT_LIBRARIES}
      onLoad={handleApiLoad}
      onError={handleApiError}
      language={locale}
      region={DEFAULT_REGION}
    >
      {children}
    </APIProvider>
  );
};

export default MapProvider;
